import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['bakery', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3,-3h1.5v1h-1.5zM-0.5,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM-3,-2h1v0.5h-1zM0,-2h0.5v2.5h-0.5zM1,-2h0.5v1h-0.5zM2,-2h0.5v0.5h-0.5zM-3,-1.5h0.5v1.5h-0.5z',
    },
    {
      paint: [
        ['bakery', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M2,-3h1v1h-1zM-1,-2.5h0.5v0.5h-0.5zM0,-2.5h0.5v0.5h-0.5zM1,-2.5h0.5v0.5h-0.5zM-0.5,-2h0.5v0.5h-0.5zM0.5,-2h0.5v1h-0.5zM2.5,-2h0.5v0.5h-0.5zM-2.5,-1.5h0.5v1.5h-0.5zM2,-1.5h1v0.5h-1zM0.5,-1h2.5v1h-2.5zM0.5,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'roofA',
      d: 'M-1.5,-6h0.5v0.5h-0.5zM-2,-5.5h1v0.5h-1zM-2.5,-5h2v0.5h-2zM-3,-4.5h2.5v0.5h-2.5zM-3.5,-4h3.5v0.5h-3.5zM-3.5,-3.5h0.5v0.5h-0.5zM-2.5,-3.5h2.5v0.5h-2.5zM3,-3.5h0.5v0.5h-0.5zM-1,-3h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofA', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-1,-6h1v0.5h-1zM-1,-5.5h2v0.5h-2zM-0.5,-5h2v0.5h-2zM2,-5h0.5v0.5h-0.5zM-0.5,-4.5h3.5v0.5h-3.5zM0,-4h3.5v0.5h-3.5zM0,-3.5h3v0.5h-3zM0.5,-3h1.5v0.5h-1.5zM0.5,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'chimney',
      d: 'M1,-7h1.5v2h-1.5zM1.5,-5h0.5v0.5h-0.5zM-3,-3.5h0.5v0.5h-0.5zM-1.5,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-1.5,-2.5h0.5v0.5h-0.5zM-2,-2h1.5v0.5h-1.5zM-2,-1.5h1v0.5h-1zM-0.5,-1.5h0.5v1h-0.5zM-2,-1h0.5v0.5h-0.5zM-2,-0.5h2v0.5h-2zM-1,0h1v0.5h-1z',
    },
    { paint: 'wheat', d: 'M-1,-1.5h0.5v0.5h-0.5zM-1.5,-1h1v0.5h-1z' },
    { paint: 'lanternGlow', d: 'M1.5,-2h0.5v1h-0.5z' },
    { paint: 'smoke', d: 'M1.5,-8h0.5v0.5h-0.5z' },
  ],
  pixels: 150,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
